

module.exports = __webpack_require__.stylable.create(
    "TableCell2901549925",
    {"classes":{"root":"TableCell2901549925__root","CellExt":"TableCell2901549925__CellExt"},"vars":{},"stVars":{"FontColor":"\"fallback(color(--currentFontColor), fallback(color(--runningTextColor), color(color-5)))\"","BorderWidth":"'\"unit(fallback(--cellBorderWidth, 1), px)\"'","FocusedBorderWidth":"\"calculate(*, -1, unit(fallback(--cellBorderWidth, 1), px))\"","BorderColor":"\"fallback(color(--cellBorderColor), fallback(color(--borderColor), color(color-2)))\"","BackgroundColor":"\"fallback(color(--cellBackgroundColor), fallback(color(--bgBoxColor), color(color-1)))\"","TodayBorderWidth":"\"calculate(*, -1, unit(fallback(--cellBorderWidth, 1), px))\""},"keyframes":{}},
    "",
    17,
    "TableCell2901549925",
    null
);
